import React, { useEffect, useCallback, useState} from 'react';
import EffectOption from './EffectOption.js';
import Dropdown from 'react-dropdown';
import MidiEffectComponent from 'components/effects/MidiEffectComponent.js';
import Colors from 'components/Colors.js';
import SendEffect from '../../track/SendEffect.js';
import {midiEffectOptions, getMidiEffectOption, initializeMidiEffect} from 'components/effects/constants.js';
import {connect} from 'react-redux';
import {
    setSelectedMixEffect,
} from 'actions/index.js';

const colors = new Colors();

const AudioEffects = ({
    currentSubSequence,
    track,
    sequencerEngine,
    selectedEffect,
    setSelectedEffect}) => { 
        let [value, setValue] = useState(undefined);
        let effects = track ? track.midiEffects.effects : [];
        
        const moveEffectTo = useCallback((from, to) => {
            track.moveMidiEffectTo(from, to);
            setValue({from, to});
        }, [track, setValue]);
        
        const onDelete = useCallback(() => {
            setSelectedEffect(currentSubSequence, track.id, undefined, undefined);
        }, [currentSubSequence, track]);

        let fxComponent = '';
        if (selectedEffect && effects.some(e => e.id === selectedEffect.id)) {
            fxComponent = (
                <MidiEffectComponent
                  sequencerEngine={sequencerEngine}
                  isDraggable={false}
                  track={track}
                  compact={true}
                  onDeleteEffect={() => onDelete()}
                  effect={selectedEffect}
                  send={undefined}/>);
        }

        const handleChooseEffect = useCallback((e) => {
            let effect = initializeMidiEffect(e.value, track);
            track.midiEffects.addEffect(effect);
            setSelectedEffect(currentSubSequence, track.id, undefined, effect);
            return false;
        }, [setValue, sequencerEngine, track]);

        let name = "";
        let style = {
        };
        console.log("SELECTED EFFECT =" , selectedEffect);
        return (
            <div className="audio-effects">
              <div
                style={style}
                className="effects-channel-strip">
               <div className="effects-list">
                  {effects.map(
                      (effect, i) =>
                          <EffectOption
                            key={effect.id}
                            track={track}
                            currentSubSequence={track}
                            effectType={"MIDI_FX"}
                            moveEffectTo={moveEffectTo}
                            effectNumber={i}
                            effect={effect}/>)}
                </div>
                <Dropdown
                  className='send-effects-dropdown'
                  options={midiEffectOptions}
                  onChange={handleChooseEffect}
                  placeholder="MIDI FX" />
             </div>

              <div className="effects-view">
                {fxComponent}
              </div>
            </div>);
    }

const mapStateToProps = (state, props) => {
    let selectedTrack = props.track.id;
    let selectedGroup = state.mix.selectedGroup;
    let subId = state.sequencer.currentSubSequence[props.sequencerEngine.engineId];
    let track = props.track;
    return {
        selectedTrack, 
        selectedGroup,
        effectsLength: track.midiEffects.effects.length,
        selectedEffect: selectedTrack !== undefined ? state.mix.selectedTrackMidiEffects[subId] &&
            state.mix.selectedTrackMidiEffects[subId][selectedTrack] :
            undefined,
        currentSubSequence: state.sequencer.currentSubSequence[props.sequencerEngine.engineId],
    };
};

const mapDispatchToProps = (dispatch, props) => {
    return {
        setSelectedEffect: (sub, trackNumber, groupNumber, effect) => dispatch(
            setSelectedMixEffect(sub, trackNumber, groupNumber, "MIDI_FX", effect))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AudioEffects);
